module.exports = __webpack_public_path__ + "static/media/fontbonne-academy.8d46d619.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/fontbonne-academy.jpeg
// module id = 621
// module chunks = 0